/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const referralListItemSchema = z.object({
  id: z.number(),
  inviterUserId: z.string(),
  inviteeUserId: z.string(),
  status: z.string(),
  abuseFlag: z.string().nullable(),
  rewardTier: z.string().nullable(),
  rewardDays: z.number().nullable(),
  activatedAt: z.number().nullable(),
  rewardedAt: z.number().nullable(),
  createdAt: z.number(),
});

export const listReferralsV1ResponseDataSchema = z.object({
  items: z.array(referralListItemSchema),
});

export type IListReferralsV1ResponseData = z.infer<typeof listReferralsV1ResponseDataSchema>;

export const listReferralsV1ResponseSchema = createApiResponseSchema(
  listReferralsV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IListReferralsV1ResponseData>>;

export type IListReferralsV1Response = IAPI<IListReferralsV1ResponseData>;
